import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

/**
 * Fades and slides its children in when they scroll into view.
 *
 * @component
 * @param {string} as - The motion element to render (default "div").
 * @param {number} delay - Animation delay in seconds.
 */

const Reveal = ({ as = "div", delay = 0, className, children, ...rest }) => {
  const [ref, inView] = useInView({ threshold: 0.15, triggerOnce: true });
  const Component = motion[as];

  return (
    <Component
      ref={ref}
      className={className}
      initial={{ y: 30, opacity: 0 }}
      animate={inView ? { y: 0, opacity: 1 } : { y: 30, opacity: 0 }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
